__turbopack_context__.v({
  "footer": "iKbjxW_footer",
});
